module.exports = __webpack_public_path__ + "static/media/non_ulip.17fbb787.mp3";